/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/shadcnComponents/ui/use-toast";

import "./DashBoard.css";

import { useBrand } from "@/Providers/Brand";
import { useStaticData } from "@/Providers/Data";
import { useAuth } from "@/Providers/Auth";
import { useGeneralSettings } from "@/Providers/General";

import { IoIosArrowDown, IoMdOpen } from "react-icons/io";
import { BsGenderFemale } from "react-icons/bs";
import { HiOutlineUserGroup } from "react-icons/hi";
import { IoPeopleOutline } from "react-icons/io5";
import { MdOutlinePostAdd } from "react-icons/md";
import { CiLock } from "react-icons/ci";
import { FiChevronRight } from "react-icons/fi";
import { IoDiamondOutline } from "react-icons/io5";

import { Button1 } from "@/Components/Buttons";
import { FilterOptionModal, SideModal } from "@/Components/Brand/modals/Modals";
import CircleLoader from "@/Components/Brand/Loader/Loader";
import { useCookies } from "react-cookie";
import { BriefcaseIcon, DollarSignIcon, LinkedinIcon } from "lucide-react";
import { Button } from "@/shadcnComponents/ui/button";
import mixpanel from "mixpanel-browser";

export const TypeCard = ({
  item,
  Objkey,
  borderRadius,
  bg,
  padding,
  locked,
  LinkObjKey,
  subItem,
  masterData,
  masterItemName,
  masterIconName,
}) => {
  return (
    <div
      style={{
        display: Objkey
          ? item?.[Objkey]
            ? "flex"
            : "none"
          : item
            ? "flex"
            : "none",
        borderRadius: borderRadius || "",
        background: bg || "",
        padding: padding || "",
      }}
      className="typeWrapper"
    >
      {masterIconName && (
        <div
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <img
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            src={
              Objkey
                ? masterData?.find(
                    (masterItem) => masterItem?._id === item?.[Objkey]
                  )?.[masterIconName]
                : masterData?.find((masterItem) => masterItem?._id === item)?.[
                    masterIconName
                  ]
            }
            alt=""
          />
        </div>
      )}

      <div className="flex-col">
        {Objkey ? (
          <h1>
            {masterData
              ? masterData?.find(
                  (masterItem) => masterItem?._id === item?.[Objkey]
                )?.[masterItemName]
              : item?.[Objkey]}{" "}
          </h1>
        ) : (
          <h1>
            {masterData
              ? masterData?.find((masterItem) => masterItem?._id === item)?.[
                  masterItemName
                ]
              : item?.slice(0, 27)}
          </h1>
        )}
        {subItem && `${subItem}`}
      </div>
      <div
        onClick={
          !locked
            ? LinkObjKey
              ? () => {
                  if (!/^https?:\/\//i.test(item?.[LinkObjKey])) {
                    const profileLink = "https://" + item?.[LinkObjKey];
                    return window.open(profileLink, "_blank");
                  }

                  window.open(item?.[LinkObjKey], "_blank");
                }
              : () => console.log("")
            : () => alert("profile is locked!")
        }
        style={{ cursor: "pointer", display: !LinkObjKey ? "none" : "flex" }}
      >
        {locked ? (
          <CiLock color="#424242" size={16} />
        ) : (
          <FiChevronRight color="#424242" size={16} />
        )}
      </div>
    </div>
  );
};

function convertToReadableFormat(number) {
  if (Math.abs(number) >= 1000000000) {
    return (number / 1000000000).toFixed(1) + "B";
  } else if (Math.abs(number) >= 1000000) {
    return (number / 1000000).toFixed(1) + "M";
  } else if (Math.abs(number) >= 1000) {
    return (number / 1000).toFixed(1) + "K";
  } else {
    return number.toString();
  }
}

export const Contentcard = (props) => {
  return (
    <div style={{ background: props?.bg }} className="DashboardContentCard">
      <h1 style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {props?.icon}
        {props?.heading} ({props?.number})
      </h1>
      <div className="DashBoardContentCardItemList">
        {props?.type?.slice(0, props?.limit)?.map((item) => {
          return (
            <TypeCard
              item={item}
              subItem={props.subItem}
              Objkey={props?.Objkey}
              borderRadius={props?.borderRadius}
              locked={props?.locked}
              LinkObjKey={props?.LinkObjKey}
              bg={undefined}
              padding={props?.padding}
              masterData={props?.masterData}
              masterItemName={props?.masterItemName}
              masterIconName={props?.masterIconName}
            />
          );
        })}
        {props?.limit > 0 && props?.type?.length > props?.limit && (
          <>
            <div className=" text-[#424242] text-[12px] font-[400]  flex px-[12px] py-[6px] ">
              +{props?.type?.length - props?.limit} More
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export const FilterCard = ({
  list,
  item,
  icon,
  setfilters,
  filters,
  onMouseEnter,
  onMouseLeave,
  onClick,
  isMasterMapped,
}) => {
  const handleClick = (event) => {
    // const targetElement = event.target;
    // const rect = targetElement.getBoundingClientRect();
    // const mouseXRelativeToElement = event.clientX
    // const mouseYRelativeToElement = event.clientY
    // console.log(
    //   "Mouse clicked relative to element at: " +
    //     mouseXRelativeToElement +
    //     ", " +
    //     mouseYRelativeToElement
    // );
    onClick();
  };

  return (
    <div
      onClick={() => handleClick(event)}
      // onMouseEnter={() => onMouseEnter()}
      // onMouseLeave={()=>onMouseLeave()}
      className="filterCard"
    >
      {icon}
      <div
        style={
          filters?.length
            ? {
                background: "#EEEEEE",
                borderRadius: "120px",
                padding: "4px 8px",
                fontSize: "12px",
                lineHeight: "14px",
              }
            : {}
        }
      >
        {filters?.length
          ? isMasterMapped
            ? list?.find((masteritem) => masteritem?._id === filters?.[0])?.[
                isMasterMapped
              ]
            : filters?.[0]
          : item}
      </div>
      {filters?.length > 1 && <div>{`+${filters?.length - 1}`}</div>}
      {<IoIosArrowDown />}
    </div>
  );
};

export const DashBoard = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [cookies] = useCookies();
  const [AllInfluencers, SetAllInfluencers] = useState(null);
  const [FilteredInfluencer, SetFilteredInfluencer] = useState(null);
  const [numFetchedInfluencers, setNumFetchedInfluencers] = useState(10);
  const [TotalInfluencers, setTotalInfluencer] = useState(0);
  const [DummyMaleProfiles, SetDummyMaleprofiles] = useState([]);
  const [DummyFemaleProfiles, SetDummyFemaleprofiles] = useState([]);

  // const [, SetOpenModal] = useState(false);
  // const [, OpenSuccessModal] = useState(false);
  const [filterModal, OpenFilterModal] = useState(false);
  const [AdvandeModal, OpenAdvanceModal] = useState(false);
  const [Loading, setLoading] = useState(false);

  const brandState = useBrand();
  const authState = useAuth();
  const generalState = useGeneralSettings();
  const staticDataState = useStaticData();

  //filters
  const [List, SetList] = useState([]);
  const [Followers] = useState([
    "1k-5k",
    "5k-10k",
    "10k-15k",
    "15k-20k",
    "20k-30k",
    "30k-50k",
    "50k-100k",
    "More than 100k",
  ]);
  const [Gender] = useState(["Male", "Female", "Other"]);
  const [collaboratedWithBrand, SetCollaboratedWithBrand] = useState([
    "Yes",
    "No",
  ]);
  const [ContentType, setContenType] = useState([]);
  const [AudienceType, setAudienceype] = useState([]);

  //state and setters for FilterOptionModal
  const [selectedFilterState, setSelectedFilterState] = useState([]);
  const [selectedFilterSetter, setSelectedFilterSetter] = useState(() => {});

  //selected filters
  const [selectedFollowersFilters, setSelectedFollowersFilters] = useState([]);
  const [selectedContentTypeFilters, setSelectedContentTypeFilters] = useState(
    []
  );
  const [selectedAudienceTypeFilters, setSelectedAudienceTypeFilters] =
    useState([]);
  const [selectedCollaboratedWithBrand, setSelectedCollaboratedWithBrand] =
    useState([]);
  const [selectedGenderFilters, setSelectedGenderFilters] = useState([]);
  const [selectedFilterPosition, setSelectedFilterPostion] = useState(0);
  const [selectMasterItem, setSelectedMasterItem] = useState(null);

  //Selected Advanced Filter
  const [selectedMonetizationFilters, setSelectedMonetizationFilters] =
    useState([]);
  const [selectedPaidAudienceFilters, setSelectedPaidAudienceFilters] =
    useState([]);
  const [selectedCollaboratedWithFilters, setSelectedCollaboratedWithFilters] =
    useState([]);
  const [selectedCampaignGoalsFilters, setSelectedCampaignGoalsFilters] =
    useState([]);
  const [selectedLocationFilters, setSelectedLocationFilters] = useState([]);
  const [selectedCrossPlatformFilters, setSelectedCrossPlatformFilters] =
    useState([]);

  // //SlectedInfluenceData
  // const [, setSelectedInfluencerCoins] = useState(0);
  // const [, setSelectedInfluencerName] = useState("");
  // const [, setSelectedInfluencerProfile] = useState("");
  // const [selectedInfluencerID, setSelectedInfluencerID] = useState(null);

  //master data
  const [masterContentCategory, setMasterContentCategory] = useState([]);
  const [, setMasterContentFormat] = useState([]);
  const [, setMasterAudienceTypes] = useState([]);
  const [, setMasterAudiencePlatfroms] = useState([]);
  const [, setMasterCollabGoals] = useState([]);
  const [, setMasterMonetizationPlatform] = useState([]);
  const [, setMasterMonetizationServices] = useState([]);

  // mixpanel
  useEffect(() => {
    mixpanel.track("Brand Dicover Page Visited");
  }, []);

  useEffect(() => {
    staticDataState?.getNewDataFromType("Content Type").then((e) => {
      setMasterContentCategory(e);
    });
    staticDataState?.getNewDataFromType("Content Format").then((e) => {
      setMasterContentFormat(e);
    });
    staticDataState?.getNewDataFromType("Audience Category").then((e) => {
      setMasterAudienceTypes(e);
    });
    staticDataState?.getNewDataFromType("Audience Platform").then((e) => {
      setMasterAudiencePlatfroms(e);
    });
    staticDataState?.getNewDataFromType("Goal / KPI").then((e) => {
      setMasterCollabGoals(e);
    });
    staticDataState?.getNewDataFromType("Platform Name").then((e) => {
      setMasterMonetizationPlatform(e);
    });
    staticDataState?.getNewDataFromType("Services list").then((e) => {
      setMasterMonetizationServices(e);
    });
  }, []);
  useEffect(() => {
    if (cookies.unlockCreatorSearch) {
      navigate("/Brand/DashBoard/UnlockInfluencerSearch");
    }
  });
  useEffect(() => {
    async function getAllInfluencers() {
      setLoading(true);
      const result = await brandState?.getAllInfluencersData(0, 0);
      if (result?.success) {
        SetAllInfluencers(result?.AllInfluencers);
        SetFilteredInfluencer(result?.AllInfluencers);
        setTotalInfluencer(result?.Length);
        setLoading(false);
      } else {
        setLoading(false);
        toast({
          title: result?.Error,
          variant: "destructive",
        });
      }
    }
    async function getAllFilters() {
      const result = await staticDataState?.getNewDataFromType("Content Type");
      if (result) {
        setContenType(result);
      }
      const result2 =
        await staticDataState?.getNewDataFromType("Audience Category");
      if (result2) {
        setAudienceype(result2);
      }
    }
    async function getDummyprofile() {
      const result = await staticDataState?.getDataFromType("Dummy Profiles");
      if (result) {
        SetDummyMaleprofiles(result[0]?.male);
        SetDummyFemaleprofiles(result[0]?.female);
      }
    }
    getDummyprofile();
    getAllInfluencers();
    getAllFilters();
  }, []);
  useEffect(() => {
    setSelectedFilterState(selectedFollowersFilters);
  }, [selectedFollowersFilters]);
  useEffect(() => {
    setSelectedFilterState(selectedContentTypeFilters);
  }, [selectedContentTypeFilters]);
  useEffect(() => {
    setSelectedFilterState(selectedAudienceTypeFilters);
  }, [selectedAudienceTypeFilters]);
  useEffect(() => {
    setSelectedFilterState(selectedGenderFilters);
  }, [selectedGenderFilters]);
  useEffect(() => {
    setSelectedFilterState(selectedCollaboratedWithBrand);
  }, [selectedCollaboratedWithBrand]);
  useEffect(() => {
    setNumFetchedInfluencers(AllInfluencers?.length);
  }, [AllInfluencers]);
  useEffect(() => {
    if (FilteredInfluencer) {
      const updatedInfluencers = FilteredInfluencer.map((influencer) => {
        if (!influencer?.influencerData?.profile) {
          return {
            ...influencer,
            influencerData: {
              ...influencer.influencerData,
              profile:
                influencer?.influencerData?.gender === "Male"
                  ? getMaleDummyprofile()
                  : getFemaleDummyprofile(),
            },
          };
        }
        return influencer;
      });
      SetFilteredInfluencer(updatedInfluencers);
    }
  }, [AllInfluencers]);

  const getMaleDummyprofile = () => {
    const index = Math.floor(Math.random() * 25);
    return DummyMaleProfiles[index];
  };
  const getFemaleDummyprofile = () => {
    const index = Math.floor(Math.random() * 25);
    return DummyFemaleProfiles[index];
  };

  // convertoreadableformat moved as global function

  const handleFilterCardClick = (
    filterList,
    filters,
    setFilterFunction,
    position,
    masterItemName
  ) => {
    SetList(filterList);
    setSelectedFilterState(filters);
    setSelectedFilterSetter(() => setFilterFunction);
    setSelectedFilterPostion(position);
    OpenFilterModal(true);

    setSelectedMasterItem(masterItemName);
  };

  // const handleUnlockButtonClick = (coins, name, profile, id) => {
  //   setSelectedInfluencerCoins(coins);
  //   setSelectedInfluencerName(name);
  //   setSelectedInfluencerProfile(profile);
  //   setSelectedInfluencerID(id);
  //   SetOpenModal(true);
  // };

  // const handleBuyClick = async () => {
  //   SetOpenModal(false);
  //   generalState?.setLoading(true);
  //   const result = await brandState?.getInfluencerWithCredits(
  //     selectedInfluencerID,
  //     false
  //   );
  //   if (result?.success) {
  //     generalState.setLoading(false);
  //     const result2 = await brandState?.getInfluencerPersonalInfo(
  //       selectedInfluencerID
  //     );
  //     if (result2?.success) {
  //       setSelectedInfluencerName(result2?.data?.name);
  //       setSelectedInfluencerProfile(result2?.data?.profile);
  //       OpenSuccessModal(true);
  //       authState?.setReFetchBrandData((prev) => !prev);
  //     } else {
  //       generalState.setLoading(false);
  //       toast({
  //         title: result2?.Error,
  //         variant: "destructive",
  //       });
  //     }
  //   } else {
  //     console.log(result);
  //     generalState.setLoading(false);
  //     toast({
  //       title: result?.Error,
  //       variant: "destructive",
  //     });
  //   }
  // };

  const handleFilterSearch = async () => {
    generalState?.setLoading(true);
    const newInfluencers = await brandState?.getAllInfluencersData(
      0,
      10,
      selectedAudienceTypeFilters,
      selectedContentTypeFilters,
      selectedCollaboratedWithBrand,
      selectedFollowersFilters,
      selectedGenderFilters,
      [],
      [],
      [],
      [],
      [],
      []
    );
    if (newInfluencers?.success) {
      SetAllInfluencers(newInfluencers?.AllInfluencers);
      SetFilteredInfluencer(newInfluencers?.AllInfluencers);
      setTotalInfluencer(newInfluencers?.Length);
      generalState?.setLoading(false);
    } else {
      generalState?.setLoading(false);
      alert(newInfluencers?.error);
    }
  };
  const handleAdvanceFilterSearch = async () => {
    generalState?.setLoading(true);
    OpenAdvanceModal(false);
    if (
      !authState?.loggedBrand?.currentPlan?.planOfferings?.AllowAdvanceFilter
    ) {
      generalState?.setLoading(false);

      return toast({
        title:
          "Advance Filters are not supported In current Plan, Please Update your plan",
        variant: "destructive",
      });
    }
    const newInfluencers = await brandState?.getAllInfluencersData(
      0,
      10,
      selectedAudienceTypeFilters,
      selectedContentTypeFilters,
      selectedCollaboratedWithBrand,
      selectedFollowersFilters,
      selectedGenderFilters,
      selectedMonetizationFilters,
      selectedPaidAudienceFilters,
      selectedCollaboratedWithFilters,
      selectedCampaignGoalsFilters,
      selectedLocationFilters,
      selectedCrossPlatformFilters
    );
    if (newInfluencers?.success) {
      SetAllInfluencers(newInfluencers?.AllInfluencers);
      SetFilteredInfluencer(newInfluencers?.AllInfluencers);
      setTotalInfluencer(newInfluencers?.Length);
      generalState?.setLoading(false);
    } else {
      generalState?.setLoading(false);
      alert(newInfluencers?.error);
    }
  };

  const handleViewMore = async () => {
    generalState?.setLoading(true);
    const newInfluencers = await brandState?.getAllInfluencersData(
      numFetchedInfluencers,
      10,
      selectedAudienceTypeFilters,
      selectedContentTypeFilters,
      selectedCollaboratedWithBrand,
      selectedFollowersFilters
    );
    if (newInfluencers.success) {
      SetAllInfluencers([...AllInfluencers, ...newInfluencers.AllInfluencers]);
      SetFilteredInfluencer([
        ...FilteredInfluencer,
        ...newInfluencers.AllInfluencers,
      ]);
      setTotalInfluencer(newInfluencers?.Length);
      generalState.setLoading(false);
      // setNumFetchedInfluencers(numFetchedInfluencers + 10);
    } else {
      generalState?.setLoading(false);
      alert(newInfluencers.error);
    }
  };

  return (
    <>
      {AdvandeModal && (
        <SideModal
          OnClose={() => OpenAdvanceModal(false)}
          OnClick={() => handleAdvanceFilterSearch()}
          selectedMonetizationFilters={selectedMonetizationFilters}
          setSelectedMonetizationFilters={setSelectedMonetizationFilters}
          selectedPaidAudienceFilters={selectedPaidAudienceFilters}
          setSelectedPaidAudienceFilters={setSelectedPaidAudienceFilters}
          selectedCollaboratedWithFilters={selectedCollaboratedWithFilters}
          setSelectedCollaboratedWithFilters={
            setSelectedCollaboratedWithFilters
          }
          selectedCampaignGoalsFilters={selectedCampaignGoalsFilters}
          setSelectedCampaignGoalsFilters={setSelectedCampaignGoalsFilters}
          selectedLocationFilters={selectedLocationFilters}
          setSelectedLocationFilters={setSelectedLocationFilters}
          selectedCrossPlatformFilters={selectedCrossPlatformFilters}
          setSelectedCrossPlatformFilters={setSelectedCrossPlatformFilters}
        />
      )}
      <div className="brandDashBoardContainer">
        <h1>Discover Influencer</h1>
        <div className="DashboardFilterContainer">
          <div
            style={{
              display: "flex",
              width: "100%",
              flexGrow: 1,
              position: "relative",
            }}
          >
            <div className="MaindashBoardFilterWrapper">
              <FilterCard
                list={Followers}
                onClick={() =>
                  handleFilterCardClick(
                    Followers,
                    selectedFollowersFilters,
                    setSelectedFollowersFilters,
                    0
                  )
                }
                onMouseEnter={() => OpenFilterModal(true)}
                onMouseLeave={() => OpenFilterModal(false)}
                filters={selectedFollowersFilters}
                setfilters={setSelectedFollowersFilters}
                item={"Followers"}
                icon={<IoPeopleOutline />}
                isMasterMapped={undefined}
              />
              <FilterCard
                list={ContentType}
                onClick={() =>
                  handleFilterCardClick(
                    ContentType,
                    selectedContentTypeFilters,
                    setSelectedContentTypeFilters,
                    1,
                    "categoryName"
                  )
                }
                onMouseEnter={() => OpenFilterModal(true)}
                onMouseLeave={() => OpenFilterModal(false)}
                filters={selectedContentTypeFilters}
                setfilters={setSelectedContentTypeFilters}
                item={"Content Type"}
                icon={<MdOutlinePostAdd />}
                isMasterMapped={"categoryName"}
              />
              <FilterCard
                item={"Audience Type"}
                onClick={() =>
                  handleFilterCardClick(
                    AudienceType,
                    selectedAudienceTypeFilters,
                    setSelectedAudienceTypeFilters,
                    2,
                    "audienceTypeName"
                  )
                }
                filters={selectedAudienceTypeFilters}
                list={AudienceType}
                setfilters={setSelectedAudienceTypeFilters}
                icon={<HiOutlineUserGroup />}
                onMouseEnter={() => OpenFilterModal(true)}
                onMouseLeave={() => OpenFilterModal(false)}
                isMasterMapped={"audienceTypeName"}
              />
              <FilterCard
                filters={selectedCollaboratedWithBrand}
                list={collaboratedWithBrand}
                setfilters={SetCollaboratedWithBrand}
                item={"Collaborated with brands"}
                onClick={() =>
                  handleFilterCardClick(
                    collaboratedWithBrand,
                    selectedCollaboratedWithBrand,
                    setSelectedCollaboratedWithBrand,
                    3
                  )
                }
                onMouseEnter={() => OpenFilterModal(true)}
                onMouseLeave={() => OpenFilterModal(false)}
                icon={
                  <div>
                    <img
                      style={{ width: "16px", height: "16px" }}
                      src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/collabfilter.svg"
                      alt=""
                    />
                  </div>
                }
                isMasterMapped={undefined}
              />
              <FilterCard
                filters={selectedGenderFilters}
                list={Gender}
                setfilters={setSelectedGenderFilters}
                onClick={() =>
                  handleFilterCardClick(
                    Gender,
                    selectedGenderFilters,
                    setSelectedGenderFilters,
                    4
                  )
                }
                onMouseLeave={() => OpenFilterModal(false)}
                item={"Gender"}
                icon={<BsGenderFemale />}
                onMouseEnter={() => OpenFilterModal(true)}
                isMasterMapped={undefined}
              />
              {/* <FilterCard item={"Gender"} icon={<BsGenderFemale />} />
              <FilterCard item={"Gender"} icon={<BsGenderFemale />} />
              <FilterCard item={"Gender"} icon={<BsGenderFemale />} /> */}
            </div>

            {filterModal && (
              <FilterOptionModal
                filters={selectedFilterState}
                setfilters={selectedFilterSetter}
                list={List}
                position={selectedFilterPosition}
                onClose={() => OpenFilterModal(false)}
                masterItemName={selectMasterItem}
              />
            )}

            <div className="FilterSearchWrapper">
              <Button1
                onClick={() => {
                  mixpanel.track("Filter Search Button Clicked");
                  handleFilterSearch();
                }}
                icon={""}
                rightIcon={""}
                text="Search"
                background={undefined}
                textColor={undefined}
                borderColor={undefined}
              />
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <button
              style={{ cursor: "pointer" }}
              onClick={() => {
                mixpanel.track("Advance Filter Button Clicked");
                OpenAdvanceModal(true);
              }}
              className="AdvanceFilter"
            >
              <IoDiamondOutline /> Advance filter
            </button>
          </div>
        </div>
        <div className="flex justify-between item-center">
          <h2>List of creators ({TotalInfluencers}) </h2>
          <div
            onClick={() => {
              mixpanel.track("Unlocked Influencer Sample Button - Clicked");
              window?.open(
                `/Brand/DashBoard/UnlockedInfluencer/Sample`,
                "self"
              );
            }}
            className="mt-[60px] text-[14px] cursor-pointer flex items-center justify-center gap-[4px]  text-[#FF5C5C] font-inter font-[600] underline uppercase"
          >
            Unlocked Influencer Sample <IoMdOpen size={16} />
          </div>
        </div>

        {/* 10/05 new UI List of All Creators */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {Loading && <CircleLoader />}
          {FilteredInfluencer?.map((influencer, index) => {
            return (
              <CreatorCard
                key={index}
                sno={index + 1}
                name={influencer?.influencerData?.name}
                followers={influencer?.influencerData?.LinkedInFollowers}
                noOfCollab={influencer?.collabData?.[0]?.data?.length}
                noOfMonetization={influencer?.MonetizedData?.[0]?.data?.length}
                creditRequired={influencer?.ChipsRequiredToUnlock}
                contentCategory={influencer?.ContentCategory?.[0]}
                masterData={masterContentCategory}
                id={influencer?._id}
                isfeatured={influencer?.is_featured}
              />
            );
          })}
        </div>

        {FilteredInfluencer?.length < TotalInfluencers && (
          <div className="w-full flex justify-center align-center mt-[30px] mb-[30px]">
            <Button1
              onClick={handleViewMore}
              text="View More"
              icon={undefined}
              rightIcon={undefined}
              background={undefined}
              textColor={undefined}
              borderColor={undefined}
            />
          </div>
        )}
      </div>
    </>
  );
};

type CreatorCardProps = {
  sno: number;
  name: string;
  followers: string;
  noOfCollab: number;
  noOfMonetization: number;
  creditRequired: number;
  contentCategory?: string[];
  masterData?: any[];
  id?: string;
  isfeatured?: boolean;
};

const CreatorCard = ({
  sno,
  name,
  followers,
  noOfCollab,
  noOfMonetization,
  creditRequired,
  contentCategory,
  masterData,
  id,
  isfeatured,
}: CreatorCardProps) => {
  const navigate = useNavigate();

  const handleViewDetail = () => {
    mixpanel.track("Creator Card: View Details Button - Clicked", {
      creatorId: id,
    });
    navigate(`/Brand/DashBoard/l/profile/${id}`);
  };

  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="h-full p-6 flex flex-col justify-between">
        <div>
          <div className="flex items-center justify-between mb-4">
            <span className="text-gray-500 font-medium">#{sno}</span>
            {isfeatured && (
              <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                Featured
              </span>
            )}
          </div>
          <h3 className="text-lg font-semibold mb-2">{name}</h3>
          <div className="flex items-center space-x-2 mb-4">
            <LinkedinIcon className="h-4 w-4 text-gray-500" />
            <span className="text-gray-500">
              {followers
                ? `${convertToReadableFormat(parseInt(followers))}
              Followers`
                : "Not Available"}
            </span>
          </div>
          {noOfCollab > 0 && (
            <div className="flex items-center space-x-2 mb-4">
              <BriefcaseIcon className="h-4 w-4 text-gray-500" />
              <span className="text-gray-500">{noOfCollab} Collaborations</span>
            </div>
          )}
          {noOfMonetization > 0 && (
            <div className="flex items-center space-x-2 mb-4">
              <DollarSignIcon className="h-4 w-4 text-gray-500" />
              <span className="text-gray-500">
                {noOfMonetization} Monetization Avenue
              </span>
            </div>
          )}

          {contentCategory?.length > 0 && (
            <>
              <div className="pb-2">
                <span className="text-[#6B7286] font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
                  Talks About on LinkedIn
                </span>
              </div>
              <div className="flex flex-wrap gap-2 mb-4 relative w-full">
                {contentCategory.slice(0, 3).map((item, index) => {
                  return (
                    <CategoryChip
                      key={index}
                      categoryId={item}
                      masterData={masterData}
                    />
                  );
                })}
                {contentCategory?.length > 3 && (
                  <CategoryChip text={`+${contentCategory?.length - 3} More`} />
                )}
              </div>
            </>
          )}
        </div>

        <div className="flex justify-between items-center mt-10">
          <span className="rounded-[100px] bg-[#F3F4F6] p-3 text-[#000] text-center font-[Inter] text-[12px] not-italic font-normal leading-[normal]">
            {creditRequired} Credits
          </span>
          <Button size="sm" onClick={() => handleViewDetail()}>
            View Details
          </Button>
        </div>
      </div>
    </div>
  );
};

type CategoryChipProps = {
  categoryId?: string;
  masterData?: any[];
  text?: string;
};

const CategoryChip = ({
  categoryId,
  masterData,
  text = "",
}: CategoryChipProps) => {
  const chipColors = [
    { bg: "#FFE6E6", text: "#FF6B6B" },
    { bg: "#FFF3CC", text: "#FFC107" },
    { bg: "#E6F4E6", text: "#4CAF50" },
    { bg: "#E6F0FF", text: "#2196F3" },
    { bg: "#F0E6F4", text: "#9B59B6" },
    { bg: "#FFE6EF", text: "#E91E63" },
    { bg: "#FFE6E6", text: "#F44336" },
    { bg: "#E6E4F4", text: "#673AB7" },
    { bg: "#CCF0F4", text: "#00BCD4" },
    { bg: "#E6F0CC", text: "#8BC34A" },
  ];

  const [randomColorPair, setRandomColorPair] = useState<{
    bg: string;
    text: string;
  }>();

  if (categoryId && masterData) {
    text = masterData.find((item) => item?._id === categoryId)?.categoryName;
  }

  useEffect(() => {
    setRandomColorPair(
      chipColors[Math.floor(Math.random() * chipColors.length)]
    );
  }, []);

  return (
    <span
      className="shrink-0 px-2 py-1 rounded-full text-xs font-medium"
      style={{
        backgroundColor: randomColorPair?.bg,
        color: randomColorPair?.text,
      }}
    >
      {text}
    </span>
  );
};
